import { string } from "prop-types"
import React from "react"
import Box from "./Box"
import Flex from "./Flex"
import Text from "./Text"

const BreakWord = Text.extend({
  wordBreak: "break-word",
})

function NoResults({ value }) {
  return (
    <Flex alignItems="center">
      <Box
        mx="auto"
        mt={6}
        px={5}
        py={3}
        borderRadius={100}
        bg="Ink Dark"
        display={["none", "inline-block"]}
      >
        <BreakWord fontSize={2} w={1} color="white" textAlign="center">
          No results found for &ldquo;{value}&rdquo;
        </BreakWord>
      </Box>
    </Flex>
  )
}

NoResults.propTypes = {
  value: string,
}

NoResults.defaultProps = {
  value: "",
}

export default NoResults



// WEBPACK FOOTER //
// ./src/components/NoResults.js